// extracted by mini-css-extract-plugin
module.exports = {"how-much":"HowMuch_how-much__XHY2Y"};